var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"tabIndex":_vm.tabIndex,"post":_vm.post,"posts":_vm.posts}})
}
var staticRenderFns = []

export { render, staticRenderFns }